import { Component, input } from '@angular/core';
import { VisualElementComponent } from '@features/canvas/visual-element/visual-element.component';
import { convertLpColorToCSSColor } from '@shared/lp.utils';
import { LpImageCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-image-canvas-component',
  imports: [VisualElementComponent],
  templateUrl: './lp-image-canvas-component.component.html',
  styleUrl: './lp-image-canvas-component.component.css',
})
export class LpImageCanvasComponentComponent {
  readonly convertLpColorToCSSColor = convertLpColorToCSSColor;

  comp = input.required<LpImageCanvasComponent>();
}
